import { z } from "zod";
/**
 * Results
 */ export var AuthorizationResultKind = /*#__PURE__*/ function(AuthorizationResultKind) {
    AuthorizationResultKind["Allowed"] = "allowed";
    AuthorizationResultKind["DisAllowed"] = "disallowed";
    AuthorizationResultKind["Indeterminate"] = "indeterminate";
    AuthorizationResultKind["Failure"] = "failure";
    AuthorizationResultKind["Unauthorized"] = "unauthorized";
    return AuthorizationResultKind;
}({});
/**
 * Allowed
 */ export const AuthorizationResultAllowedReasonSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("membership"),
        organizationId: z.number()
    }),
    z.object({
        kind: z.literal("scope"),
        scope: z.any()
    }),
    z.object({
        kind: z.literal("admin")
    }),
    z.object({
        // Using this to represent paywall templates
        kind: z.literal("public")
    })
]);
export const AuthorizationResultAllowedSchema = z.object({
    kind: z.literal("allowed"),
    reason: AuthorizationResultAllowedReasonSchema
});
/**
 * Unauthorized
 */ export const AuthorizationResultUnauthorizedSchema = z.object({
    kind: z.literal("unauthorized"),
    message: z.string().optional()
});
/**
 * Disallowed
 */ export const AuthorizationResultDisallowedSchema = z.object({
    kind: z.literal("disallowed"),
    message: z.string().optional()
});
/**
 * Indeterminate
 */ export const AuthorizationResultIndeterminateSchema = z.object({
    kind: z.literal("indeterminate")
});
/**
 * Failure
 */ export const AuthorizationResultFailureSchema = z.object({
    kind: z.literal("failure"),
    message: z.string().optional()
});
/**
 * Authorization Result
 */ export const AuthorizationResultSchema = z.union([
    AuthorizationResultAllowedSchema,
    AuthorizationResultDisallowedSchema,
    AuthorizationResultIndeterminateSchema,
    AuthorizationResultFailureSchema,
    AuthorizationResultUnauthorizedSchema
]);
